<template>
  <div class="gov-subsidy-setting">
    <template>
      <el-tabs v-model="activeName">
        <el-tab-pane label="线上国补说明" name="onlineSettingInfo">
          <el-form label-width="150px">
            <el-card v-for="(p_item, p_index) in onlineSettingInfo" :key="p_index"
              v-if="onlineDescType.includes(p_item.category_type)" class="box-card">
              <div slot="header">{{ p_item.category_name }}</div>
              <div>
                <el-form-item :label="p_item.category_type == 1 ? '3C类补贴描述' : '家电类补贴描述'">
                  <el-input v-model="p_item.desc" class="" style="width: 40%;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="国补领取说明">
                  <div class="pics-box">
                    <ul class="goodspic-wrap">
                      <draggable v-model="p_item.desc_images" :options="{
                        animation: 300,
                        forceFallback: false,
                        scroll: true,
                        handle: '.icon-arrows-alt',
                        draggable: `.goodspic${p_index}`,
                      }" class="components-view">
                        <li v-for="(c_item, c_index) in p_item.desc_images" :key='c_index'
                          :class="`goodspic goodspic${p_index}`" @mouseenter="picsEnter(c_item + '_' + c_index)"
                          @mouseleave="picsLeave">
                          <img :src="wximageurl + c_item" />
                          <div class="goodspic-mask" :class="(picsCurrent == (c_item + '_' + c_index)) ? 'on' : ''">
                            <div class="iconfont icon-trash-alt" @click="removePicsImg(p_index, c_index)"></div>
                            <div class="iconfont icon-arrows-alt"></div>
                          </div>
                        </li>
                      </draggable>
                    </ul>
                    <div class="upload-box" @click="handlePicsChange(p_index)">
                      <i class="iconfont icon-camera"></i>
                    </div>
                  </div>
                </el-form-item>
              </div>
            </el-card>
            <el-button type="primary" class="submit-btn" @click="onSubmit">
              保存
            </el-button>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="线下国补说明" name="offlineSettingInfo">
          <el-form label-width="150px">
            <el-card v-for="(p_item, p_index) in offlineSettingInfo" :key="p_index"
              v-if="offlineDescType.includes(p_item.category_type)" class="box-card">
              <div slot="header">{{ p_item.category_name }}</div>
              <div>
                <el-form-item :label="p_item.category_type == 3 ? '3C类补贴描述' : '家电类补贴描述'">
                  <el-input v-model="p_item.desc" class="" style="width: 40%;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="国补领取说明">
                  <div class="pics-box">
                    <ul class="goodspic-wrap">
                      <draggable v-model="p_item.desc_images" :options="{
                        animation: 300,
                        forceFallback: false,
                        scroll: true,
                        handle: '.icon-arrows-alt',
                        draggable: `.goodspic${p_index}`,
                      }" class="components-view">
                        <li v-for="(c_item, c_index) in p_item.desc_images" :key='c_index'
                          :class="`goodspic goodspic${p_index}`" @mouseenter="picsEnter(c_item + '_' + c_index)"
                          @mouseleave="picsLeave">
                          <img :src="wximageurl + c_item" />
                          <div class="goodspic-mask" :class="(picsCurrent == (c_item + '_' + c_index)) ? 'on' : ''">
                            <div class="iconfont icon-trash-alt" @click="removePicsImg(p_index, c_index)"></div>
                            <div class="iconfont icon-arrows-alt"></div>
                          </div>
                        </li>
                      </draggable>
                    </ul>
                    <div class="upload-box" @click="handlePicsChange(p_index)">
                      <i class="iconfont icon-camera"></i>
                    </div>
                  </div>
                </el-form-item>
              </div>
            </el-card>
            <el-button type="primary" class="submit-btn" @click="onSubmit">
              保存
            </el-button>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="微派商户" name="weipai">
          <el-form label-width="150px">
            <el-card class="box-card">
              <div slot="header">微派商户编码</div>
              <el-form-item>
                <el-input type="text" style="width: 370px;" v-model="weipaiForm.weipai_merchant_code" :min="0">
                </el-input>
              </el-form-item>
            </el-card>
            <el-button type="primary" class="submit-btn" @click="onSubmitWeiPai">
              保存
            </el-button>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="线下国补设置" name="offline">
          <el-form label-width="150px">
            <el-card class="box-card">
              <div slot="header">线下国补设置</div>
              <el-form-item>
                <el-input type="number" style="width: 370px;" v-model="offlineForm.days" :min="0">
                  <template slot="prepend">订金单线下未核销超过</template>
                  <template slot="append">天自动取消</template>
                </el-input>
              </el-form-item>
            </el-card>
            <el-button type="primary" class="submit-btn" @click="onSubmitOffline">
              保存
            </el-button>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </template>


  </div>
</template>
<script>
import draggable from 'vuedraggable'
import { dragIssuesOptions } from '@/consts'
import { setgovSettingDesc, getgovSettingDesc ,setWeiPai,getWeiPai} from './api'

export default {
  components: {
    draggable
  },
  data() {
    return {
      activeName: 'onlineSettingInfo',
      onlineDescType: ['1', '2'],
      offlineDescType: ['4', '5'],
      offLineType: ['3'],
      dragIssuesOptions,
      picsCurrent: -1,
      form: {
        pics: [],
      },
      weipaiForm:{
        weipai_merchant_code:'',
      },
      offlineForm:{
        days:0,
        category_type:3
      },
      onlineSettingInfo: [],
      offlineSettingInfo: [],
      loading: false
    }
  },
  mounted() {
    this.getGovSetting()
    this.getWeiPai()
  },
  methods: {
    async getGovSetting() {
      await getgovSettingDesc().then(res => {
        const data = res.data.data.settings
        let onlineDescData = [];
        let offlineDescData = []
        data.forEach((item, index) => {
          if(this.onlineDescType.includes(item.category_type)){
            onlineDescData.push(item)
          }

          if(this.offlineDescType.includes(item.category_type)){
            offlineDescData.push(item) 
          }

          if (this.offLineType.includes(item.category_type)) {
            this.offlineForm = item
          }
        })
        this.onlineSettingInfo = onlineDescData
        this.offlineSettingInfo = offlineDescData
      })
    },
    async getWeiPai() {
      await getWeiPai().then(res => {
        const data = res.data.data.weipai_merchant_code
        this.weipaiForm.weipai_merchant_code= data
      })
    },
    async handlePicsChange(index) {
      const { data } = await this.$picker.image({
        multiple: true
      })
      if (data.length > 0) {
        data.forEach(data => {
          if (data && data.url !== '') {
            this[this.activeName][index].desc_images.push(data.url)
          }
        })
      }
    },
    picsEnter(index) {
      this.picsCurrent = index
    },
    picsLeave() {
      this.picsCurrent = -1
    },
    removePicsImg: function (pindex, cindex) {
      this[this.activeName][pindex].desc_images.splice(cindex, 1)
    },
    async onSubmit() {
      console.log(this[this.activeName])
      setgovSettingDesc({ settings: this[this.activeName], type: 'desc' }).then(res => {
        this.$message.success('保存成功')
        this.getGovSetting()
      }).catch(err => {
        this.$message.error('保存失败')
      })
    },
    async onSubmitWeiPai() {
      setWeiPai(this.weipaiForm ).then(res => {
        this.$message.success('保存成功')
        this.getGovSetting()
      }).catch(err => {
        this.$message.error('保存失败')
      })
    },
    async onSubmitOffline() {
      setgovSettingDesc({ settings: [this.offlineForm],type:'offline' }).then(res => {
        this.$message.success('保存成功')
        this.getGovSetting()
      }).catch(err => {
        this.$message.error('保存失败')
      })
    }
  }
}
</script>

<style scoped lang="scss">
.gov-subsidy-setting {
  .pics-box {
    overflow: hidden;

    .goodspic-wrap {
      float: left;
      margin-right: 5px;
      overflow: hidden;

      .goodspic {
        position: relative;
        float: left;
        width: 120px;
        height: 120px;
        margin: 0 5px 10px;
        border: 1px solid #ddd;
        border-radius: 8px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }

        .goodspic-mask {
          display: none;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, .2);
          cursor: pointer;

          &.on {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .iconfont {
            margin: 0 8px;
            font-size: 20px;
            color: #fff;
          }
        }
      }
    }

    .upload-box {
      display: inline-block;
      width: 120px;
      height: 120px;
      line-height: 120px;
      text-align: center;

      .iconfont {
        font-size: 30px;
        color: #ccc;
      }
    }
  }

  .submit-btn {
    width: 150px;
    position: relative;
    bottom: 0;
    left: 45%;
  }
}
</style>
